import * as React from 'react';
/* eslint react/prop-types: 0 */
import './Navigation.scss'
import { IStatsProps } from './Stats';

export const Navigation: React.FC<IStatsProps> = (props) => {
    const dots = [];
    for (let i = 1; i <= props.totalSteps; i += 1) {
        const isActive = props.currentStep === i;
        dots.push((
            <span
                key={`step-${i}`}
                className={`dot ${isActive ? 'active' : ''}`}
                // onClick={() => props.goToStep(i)}
            >&bull;</span>
        ));
    }

    return (
        <div className="nav">{dots}</div>
    );
};